import Acl from '@/plugins/Acl'
import store from '@/store/store'

export const accessControl = new Acl()

export const isAllowed = (permission) => {
  return (to,from,next) => {
    if (store.getters.isAuthenticated && accessControl.isAllowed(permission)) {
      next()
      return
    }
    next({ name: 'login' })
  }
}

export const hasRole =  (role) => {
  return (to,from,next) => {
    if (store.getters.isAuthenticated && accessControl.hasRole(role)) {
      next()
      return
    }
    next({ name: 'login' })
  }
}
export const ifAuthenticated = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    next()
    return
  }
  next({ name: 'login' })
}

export const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next()
    return
  }
  next({ name: 'dashboard' })
}

export const ifCyclicNavigationAvalible = () => {
  if (process.env.VUE_APP_CYCLIC_FORMS=="true") {
    return true;
  }
  return false;
}

export const ifArchiveNavigationAvalible = () => {
  if (process.env.VUE_APP_ARCHIVE_MODULE=="true") {
    return true;
  }
  return false;
}

export const ifStatisticsNavigationAvalible = () => {
  if (process.env.VUE_APP_STATISTICS=="true") {
    return true;
  }
  return false;
}

export const ifCyclicAvalible = (to, from, next) => {
  if (process.env.VUE_APP_CYCLIC_FORMS=="true") {
    return ifAuthenticated(to, from, next);
  }
  next({ name: 'dashboard' })
}

export const ifStatisticsAvalible = (to, from, next) => {
  if (process.env.VUE_APP_STATISTICS=="true") {
    return ifAuthenticated(to, from, next);
  }
  next({ name: 'dashboard' })
}

export const ifArchiveModuleAvalible = (to, from, next) => {
  if (process.env.VUE_APP_ARCHIVE_MODULE=="true") {
    return  ifAuthenticated(to, from, next);
  }
  next({ name: 'dashboard' })
}

export const ifMessageModuleAvalible = () => {
  if (process.env.VUE_APP_MESSAGE_MODULE=="true") {
    return  true
  }
  return false
}
export const ifCalendarModuleAvalible = () => {
  if (process.env.VUE_APP_CALENDAR_MODULE=="true") {
    return  true
  }
  return false
}
export const ifStorageModuleAvalible = () => {
  if (process.env.VUE_APP_STORAGE_MODULE=="true") {
    return  true
  }
  return false
}
export const ifUserFileModuleAvalible = () => {
  if (process.env.VUE_APP_USER_FILE_MODULE == "true") {
    return true
  }
  return false
}
